import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import vuet from './utils/vuet'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui'


import lottie from 'vue-lottie'
import param from '../static/config/param'
// fade/zoom 等
import 'element-ui/lib/theme-chalk/base.css'
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import 'element-ui/lib/theme-chalk/index.css'
//公共组件
import vTabs from './views/components/Tabs';
import vButton from './views/components/Button';
//公共函数
import { method } from './utils/method';
//
Vue.config.productionTip = false
// collapse 展开折叠
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.component('lottie', lottie)
//全局注册公共组件
Vue.component("vTabs", vTabs);
Vue.component("vButton", vButton);
//
Vue.use(VueI18n)
//全局注册公共函数
Vue.prototype.method = method;

const i18n = new VueI18n({
  messages: {
    'constant': require('../static/i18n/constant.json'),//常量
    'common': require('../static/i18n/common.json'),//公共
    'area': require('../static/i18n/area.json'),//区域
    'device': require('../static/i18n/device.json'),//设备
    'layout': require('../static/i18n/layout.json'),//布局
    'other': require('../static/i18n/other.json'),//其他
    'user': require('../static/i18n/user.json'),//用户
    'workbench': require('../static/i18n/workbench.json'),//工作台
    'group': require('../static/i18n/group.json'),//组
    'site': require('../static/i18n/site.json'),//站点
    'role': require('../static/i18n/role.json'),//角色
    'department': require('../static/i18n/department.json'),//部门
    'distribution': require('../static/i18n/distribution.json'),//派发权限
  },
})
Vue.use(ElementUI,{
  size: 'small'
})
router.beforeEach((to, from, next) => {
  document.title=param.title
  let routes = ['/', '*', '/load', '/login']
  if (routes.indexOf(to.path) != -1) {
    next()
  } else {
    if (store.state.token != '') {
      next() // 如果有token就正常转向
    } else {
      next('/login') // 否则跳转回登录页
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  vuet,
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js